import Vue from 'vue'
import main from './main.vue'

const MainConstructor = Vue.extend(main)

let instance

const initInstance = () => {
  instance = new MainConstructor({
    el: document.createElement('div'),
  })
  document.body.appendChild(instance.$el)
}

const Factory = function (options = {}) {
  if (!instance) {
    initInstance()
  }
  for (const key in options) {
    if (instance.hasOwnProperty(key)) {
      instance[key] = options[key]
    }
  }
  instance.visible = true
}

Factory.destroy = () => {
  if (instance) {
    instance.$el.remove()
    instance.$destroy()
    instance = null
  }
}

export default Factory



// WEBPACK FOOTER //
// ./src/views/question-review/components/MarketPhotoFullScreen/src/main.js